<template>
    <div>
        <b-form-group>
          <b-form-checkbox switch v-model="participant.showParticipant" :disabled="busy">
            {{ trans('different_member') }}
            <small class="text-muted" :title="trans('different_member_about').replace(':what', trans('account_owner').toLowerCase())" v-b-tooltip.hover>
              <i class="fa fa-fw fa-info-circle"></i>
            </small>
          </b-form-checkbox>
        </b-form-group>
        <div v-if="participant.showParticipant">
            <form-question
                v-model="participant.name"
                :label="trans('name')"
                not-nullable
            />
            <form-question
                v-if="!!participant.email"
                v-model="participant.email"
                :label="trans('email')"
            />
            <form-question
                v-if="!!participant.mobile"
                v-model="participant.mobile"
                :label="trans('mobile')"
            />
            <form-question
                v-model="participant.gender"
                :label="trans('gender')"
                :name="gender_label"
                @name="gender_label = $event"
            />
            <p v-if="participant.gender" style="margin-left: 2.25em;">
                <span class="text-muted">{{ trans('gender_choices') }}:</span>
                <span>{{ printGenderChoices(participant.gender_choices) || trans('all') }}</span>
                <b-button variant="link" size="sm" class="py-0 text-muted" v-b-modal.gender-choices-modal>
                <i class="fa fa-fw fa-edit"></i>
                </b-button>
            </p>
            <gender-choices-modal
                :organization="organization"
                v-model="participant.gender_choices"
            ></gender-choices-modal>
            <form-question
                v-model="participant.date_of_birth"
                :label="trans('date_of_birth')"
            />
            <p v-if="participant.date_of_birth == 'required'" style="margin-left: 2.25em;">
                <span class="text-muted">{{ trans('age_constraint') }}:</span>
                <span>{{ printAgeConstraint(participant.age_constraint, organization) || trans('none') }}</span>
                <b-button variant="link" size="sm" class="py-0 text-muted" v-b-modal.age-constraint-modal>
                <i class="fa fa-fw fa-edit"></i>
                </b-button>
            </p>
            <age-constraint-modal
                :organization="organization"
                v-model="participant.age_constraint"
            ></age-constraint-modal>
            <form-question
                v-model="participant.grade"
                :label="trans('grade')"
            />
            <p v-if="!!participant.grade" style="margin-left: 2.25em;">
                <span class="text-muted">{{ trans('grade_choices') }}:</span>
                <span>{{ participant.grade_choices && participant.grade_choices.length > 0 ? participant.grade_choices.join(', ') : trans('none') }}</span>
                <b-button variant="link" size="sm" class="py-0 text-muted" v-b-modal.grade-choices-modal>
                <i class="fa fa-fw fa-edit"></i>
                </b-button>
            </p>
            <grade-choices-modal
                :organization="organization"
                v-model="participant.grade_choices"
            ></grade-choices-modal>
            <form-question
                v-if="false"
                v-model="participant.other_phone"
                :label="trans('other_phone')"
                :name="participant.other_phone_label"
                @name="participant.other_phone_label = $event"
            />
            <form-question
                v-if="false"
                v-model="participant.zip_postal_code"
                :label="trans('zip_postal_code')"
            />
            <form-question
                v-if="false"
                v-model="participant.address"
                :label="trans('address')"
            />
        </div>
    </div>
</template>

<script>
import Dollar from './../billing/Dollar'
import FormQuestion from './../form/FormQuestion'
import AgeConstraintModal from './AgeConstraintModal'
import GenderChoicesModal from './GenderChoicesModal'
import GradeChoicesModal from './GradeChoicesModal'

export default {
    props: {
        organization: Object,
        value: Object, // form question - can be blank
    },
    components: {
        Dollar,
        FormQuestion,
        AgeConstraintModal,
        GenderChoicesModal,
        GradeChoicesModal,
    },
    data() {
        let participant = this.value ? this.value : {}
        if (!participant.name) {
            participant.name = 'required'
        }
        return {
          trans: trans,
          moment: moment,
          numeral: numeral,
          currency: _.currency,
          isNumeric: _.isNumeric,
          printAgeConstraint: _.printAgeConstraint,
          printGenderChoices: _.printGenderChoices,
          printProRataHtml: _.printProRataHtml,
          busy: false,
          error: null,
          participant: participant
        }
    },
    watch: {
        participant() {
            this.$emit('input', this.participant);
        },
        value() {
            this.participant = this.value
        },
    },
    mounted() {
        window.formParticipantFields = this
    },
}
</script>
